function set(state, fn) {
	if (fn)
		fn(state);
}

let setValue = (state, { value, key }) => {
	state[key] = value;
};

export default {
	set,
	setValue,
};